import { useCurrentPatient } from '@/hooks/useCurrentPatient';
import { useAuth } from '@/lib/auth';
import { PortalPageHead } from '@/components/portal/PortalChrome';
import { patientInitials } from '@/components/portal/dashboard/portalDashboardUtils';

export function PortalProfile() {
  const { data: patient } = useCurrentPatient();
  const { user } = useAuth();
  const name = [patient?.first_name, patient?.last_name].filter(Boolean).join(' ');

  return (
    <>
      <PortalPageHead title="Profil" subtitle="Dine kontaktoplysninger hos klinikken." />
      <section className="card">
        <div className="row" style={{ borderTop: 0, paddingTop: 0 }}>
          <span className="avatar av48">{patientInitials(patient?.first_name, patient?.last_name)}</span>
          <div className="grow">
            <div className="t">{name || 'Patient'}</div>
            <div className="s">{user?.email ?? 'Ingen e-mail'}</div>
          </div>
        </div>
        <p className="help" style={{ marginTop: 16 }}>
          Du kan ikke rette navn og CPR her. Skriv til klinikken, hvis noget skal ændres.
        </p>
      </section>
    </>
  );
}
